module.exports = __webpack_public_path__ + "static/3-f7a6c5fb266347f5a9f672db8a8de7b2.png";